import { reports as api } from "@/api";
import {
  state as s,
  getters as g,
  actions as a,
  mutations as m,
} from "./crud-base";

const state = () => {
  return {
    ...s(),
  };
};

// getters
const getters = {
  ...g,
};

// actions
const actions = {
  ...a(api),
  async getReport(_, id) {
    const result = await api.getReport(id);
    result.validated = [];
    if (result.success) result.validated = result.data;
    return result;
  },
  async getJson(_, id) {
    const result = await api.getJson(id);
    return result;
  },
  async downloadReport(_, id) {
    const result = await api.downloadReport(id);
    return result;
  },
  async linkReport(_, { id, hash }) {
    const result = await api.linkReport(id, hash);
    return result;
  },
  async markReport(_, id) {
    const result = await api.markReport(id);
    result.validated = result.success;
    return result;
  },
  async markAll() {
    const result = await api.markAll();
    result.validated = result.success;
    return result;
  },
};

// mutations
const mutations = {
  ...m,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
